<div *ngIf="opened && !showLogin" [ngClass]="{'pad-overlay': !isModal}">
    <div class="pad-container">
        <div class="pad-outer">
            <signature-canvas #signatureCanvas name="signature" [options]="signaturePadOptions"
                (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete($event)"></signature-canvas>
        </div>
        <div class="buttons-container" *ngIf="config.showButtons">
            <button [style.background]="config.colors.primary" [style.color]="config.colors.text" type="button"
                color="primary" (click)="clearSign()" [disabled]="!isCanvasReady" *ngIf="config.buttons.clear.active"
                mat-stroked-button>
                {{ config.buttons.clear.label }}
            </button>
            <button [style.background]="config.colors.primary" [style.color]="config.colors.text" type="button"
                color="primary" (click)="isBiometry() ? signPDF() : drawSave(false, 'image/png')"
                [disabled]="!isCanvasReady" *ngIf="config.buttons.save.active" mat-flat-button>
                {{ config.buttons.save.label }}
            </button>
        </div>
    </div>
</div>

<div id="login-form" *ngIf="loginEnabled && showLogin">
    <form [formGroup]="FormLogin" class="form">
        <mat-form-field class="formField">
            <input matInput placeholder="ID de organización" formControlName="orgaid" (keyup.enter)="getIvSignToken()">
        </mat-form-field>
        <mat-form-field class="formField">
            <input matInput placeholder="Usuario" formControlName="login" (keyup.enter)="getIvSignToken()">
        </mat-form-field>
        <mat-form-field class="formField">
            <input type="password" matInput placeholder="Contraseña" formControlName="pass"
                (keyup.enter)="getIvSignToken()">
        </mat-form-field>
        <button class="btn" type="button" [color]="config.colors.primary ? null  : 'primary'"
            [style.background]="config.colors.primary" [style.color]="config.colors.text" (click)="getIvSignToken()"
            mat-flat-button>
            Acceder
        </button>
    </form>
</div>

<div class="btnContent" *ngIf="!opened && config.buttons.sign.active">
    <button type="button" color="primary" (click)="togglePad(true)" mat-raised-button>
        <i class="material-icons">gesture</i>
        {{ config.buttons.sign.label }}
    </button>
</div>

<div [hidden]="(!loading || !showLoading) && (!error || !showErrors)">
    <div class="spinner-overlay">
        <div class="spiner-overlay-inner">
            <div class="text-center spinner-container">
                <div [hidden]="!error || !showErrors">
                    Error: {{error}}
                    <div class="contentBtn">
                        <button type="button" [color]="config.colors.primary ? null  : 'primary'"
                            [style.background]="config.colors.primary" [style.color]="config.colors.text"
                            (click)="dismissError()" mat-raised-button>
                            OK
                        </button>
                    </div>
                </div>
                <mat-progress-spinner [hidden]="!loading || !showLoading" color="#00f" diameter="68"
                    mode="indeterminate" strokeWidth="8" value="33"></mat-progress-spinner>
            </div>
        </div>
    </div>
</div>
